/**
 * Overwritten by scripts/inject-api-env.js before native release bundles.
 * Do not commit non-empty production literals (same sensitivity as API base URL config).
 */
export const INJECTED_BUNDLE_ENV = '' as '' | 'production'
export const INJECTED_PRODUCTION_API_URL = ""
